
  import {prepareImageUrl} from '@/helper/ImageHelper';

  export default {
    name: 'EventCard',
    filters: {
      truncate(string, value) {
        return string.length > value
          ? string.substring(0, value) + '…'
          : string;
      },
    },
    props: {
      event: {
        type: Object,
        default: () => {},
      },
    },
    serverCacheKey: function (props) {
      // return a key based on the props. in this case, we're using the `id` prop:
      return 'event-card-' + props.event.id;
    },
    data() {
      return {
        logoUrl: process.env.NUXT_ENV_FALLBACK_CARD_IMAGE_STATIC,
      };
    },
    created() {
      if (this.event.logo) {
        this.logoUrl = prepareImageUrl(this.event.logo.url);
      }
    },
    methods: {
      formatDate(date) {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return day + '.' + month + '.' + year;
      },
    },
  };
